import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, spellCheck, ...props }, ref) => {
  // Enable the browser's native spell-check on free-type text fields so
  // ticket responses, notes, titles, etc. get red-underlined typos. Fields
  // where it would just produce noise (emails, URLs, passwords, numbers,
  // search strings, dates/times, phones) are left to the browser's own
  // defaults — those inputs typically disable spell-check already.
  const noisyTypes = new Set([
    "email", "url", "password", "number", "search", "tel",
    "date", "time", "datetime-local", "week", "month", "color", "file",
  ]);
  const effectiveSpellCheck = spellCheck ?? (noisyTypes.has(type) ? undefined : true);
  return (
    <input
      type={type}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      spellCheck={effectiveSpellCheck}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
